import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  MultiSelectFilter,
  StringFilterValue,
} from "../../shared/filters/types/filter";
import { TASK_TYPE_ID } from "./useTaskTypeFilter";
import { useActivityLocations } from "./useActivityData";
import { useLocationsOptions } from "./useLocationsOptions";

const REFILL_LOCATIONS_ID = "refillLocations";

export function useRefillLocationsFilter(
  filterValues: FilterValue[]
): MultiSelectFilter {
  const { t } = useTranslation();
  const defaultValue = {
    filterId: REFILL_LOCATIONS_ID,
    value: [],
  };

  const taskTypeValue = filterValues.find(
    ({ filterId }) => filterId === TASK_TYPE_ID
  );
  const taskTypeValueValue = (taskTypeValue as StringFilterValue)?.value ?? "";
  const isRefillLocationsAvailable =
    taskTypeValueValue === "refill" || taskTypeValueValue === "pickAndRefill";

  const enabled = isRefillLocationsAvailable;
  const { data: taskLocations, isFetching } = useActivityLocations(
    taskTypeValueValue,
    "refill",
    enabled
  );
  const options = useLocationsOptions(taskTypeValueValue, taskLocations ?? []);

  return {
    inputType: InputType.MultiSelect,
    filterType: FilterType.Filter,
    id: REFILL_LOCATIONS_ID,
    title: t("refillLocString"),
    options,
    enabled,
    defaultValue,
    showSearch: true,
    noResultsTitle: t("noLocationsString"),
    noResultsDescription: t("noLocationsAvailableTaskTypeString"),
    isFetching,
  };
}
